import React, { useEffect, useMemo, useState } from "react";
import QuoteBlock from "../Introduction/QuoteBlock";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  detailedResultState,
  feedbackStatusLoadedState,
  feedbackSubmittedState,
  resultSelector,
} from "../../../utils/recoil";
import { useTranslation } from "react-i18next";
import ResultFeedbackModal, {
  getFeedbackStorageKey,
} from "../components/ResultFeedbackModal";

const Conclusion = () => {
  const [data] = useRecoilState(detailedResultState);
  const result = useRecoilValue(resultSelector);
  const { t } = useTranslation("result");
  const storageKey = useMemo(() => getFeedbackStorageKey(result), [result]);
  const dismissedKey = useMemo(() => `${storageKey}:dismissed`, [storageKey]);
  const [visible, setVisible] = useState(false);
  const submitted = useRecoilValue(feedbackSubmittedState);
  const feedbackStatusLoaded = useRecoilValue(feedbackStatusLoadedState);

  useEffect(() => {
    const alreadySubmitted = localStorage.getItem(storageKey);
    const dismissedThisSession = sessionStorage.getItem(dismissedKey);

    if (!feedbackStatusLoaded) {
      return undefined;
    }

    if (submitted || alreadySubmitted || dismissedThisSession) {
      return undefined;
    }

    const timer = setTimeout(() => {
      setVisible(true);
    }, 7000);

    return () => clearTimeout(timer);
  }, [dismissedKey, feedbackStatusLoaded, storageKey, submitted]);

  const handleHide = () => {
    sessionStorage.setItem(dismissedKey, "true");
    setVisible(false);
  };

  return (
    <>
      <div className="px-[20rem] md-max:px-[1rem] flex flex-col gap-5 py-10">
        <p className="text-3xl md-max:text-2xl font-bold">{t("conclusion")}</p>
        <p className="text-xl md-max:text-[16px] leading-[32px]">
          {data?.conclusion}
        </p>
      </div>
      <QuoteBlock text={data?.concluding_quote} />

      {!submitted && (
        <ResultFeedbackModal
          visible={visible}
          onHide={handleHide}
        />
      )}
    </>
  );
};

export default Conclusion;
